import { IIdleTimer, useIdleTimer } from 'react-idle-timer'
import { debug } from '@util/log'
import {
  ADMIN_IDLE_STATE_INACTIVITY_MESSAGE,
  ADMIN_NUDGE_BEFORE_TIMEOUT_IN_MINUTES,
  ADMIN_TIME_OUT_IN_MINUTES,
} from '../../../constants'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@common/CustomToast'
import { useAuth } from 'react-oidc-context'

const useAdminIdle = () => {
  const { showToast } = useToast()
  const navigate = useNavigate()
  const auth = useAuth()

  const onAction = (event?: Event, idleTimer?: IIdleTimer) => {
    if (idleTimer?.isPrompted()) {
      idleTimer?.activate()
      debug('Admin user did some action')
    }
  }

  const onActive = (event?: Event, idleTimer?: IIdleTimer) => {
    if (idleTimer?.isPrompted()) {
      debug('Admin user is active again')
    }
  }

  const onPrompt = () => {
    debug('Admin user will be logged out in 5 minutes due to inactivity')
    if (Notification.permission !== 'denied') {
      const notification = new Notification(
        `You will be logged out due to inactivity in ${ADMIN_NUDGE_BEFORE_TIMEOUT_IN_MINUTES} minutes`
      )
      notification.onclick = () => {
        window.focus()
        notification.close()
      }
    }
    showToast({
      id: ADMIN_IDLE_STATE_INACTIVITY_MESSAGE,
      message: 'You will be logged out due to inactivity',
      type: 'warning',
    })
  }

  const onIdle = () => {
    debug('Admin user logged out due to inactivity')

    // Store logout reason in sessionStorage to show toast after redirect
    sessionStorage.setItem('adminLoggedOutReason', 'inactivity')

    // Sign out the user and redirect to admin login
    auth.signoutRedirect().finally(() => {
      navigate('/admin')
    })
  }

  const { start, pause } = useIdleTimer({
    name: 'admin-idle-timer',
    timeout: 1000 * 60 * ADMIN_TIME_OUT_IN_MINUTES,
    promptBeforeIdle: 1000 * 60 * ADMIN_NUDGE_BEFORE_TIMEOUT_IN_MINUTES,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
    onAction: onAction,
    onActive: onActive,
    onIdle: onIdle,
    onPrompt: onPrompt,
    startManually: true,
  })

  return { start, pause }
}

export default useAdminIdle
